/**
 * Check whether a password lives up to the requirement.
 *
 * @param {string} password
 *
 * @returns {boolean}
 */
const isPasswordValid = (password) => {
    const regex = /[^\w\d]*(([0-9]+.*[A-Za-zÆØÅæøå]+.*)|[A-Za-zÆØÅæøå]+.*([0-9]+.*))/;
    return regex.test(password);
};
export default isPasswordValid;
